import { createContext, useContext } from 'react'
import type { ModalManagerModalType } from '.'

type ModalContextType = {
  openModal: (data: ModalManagerModalType) => void
  updateModal: (
    modalId: string,
    newData: Partial<ModalManagerModalType['modal']>,
  ) => void
  closeModals: () => void
}

export const ModalContext = createContext<ModalContextType | undefined>(
  undefined,
)

export const useModals = () => {
  const context = useContext(ModalContext)

  if (!context) {
    throw new Error('useModal must be used within a ModalProvider')
  }

  return {
    modals: {
      openModal: context.openModal,
      closeModals: context.closeModals,
      updateModal: context.updateModal,
    },
  }
}
